import React, { useEffect, useState } from "react";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";

export default function PackagesPage() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchPackages = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchData("chaat/packages");
        setPackages(data.data || []);
      } catch (err) {
        setError(err.message || "حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };
    fetchPackages();
  }, []);

  return (
   <div className="p-6 mx-auto">
 
      <div className="flex items-center justify-between mb-6">
      <h2 className="text-2xl font-bold mb-4">الباقات</h2>
  
        </div>
      {loading && <div>جاري التحميل...</div>}
      {error && <div className="text-red-600">{error}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {packages.map(pkg => (
          <div key={pkg.id} className="bg-white rounded-xl shadow p-4 flex flex-col gap-2 border">
            <div className="flex justify-between items-center">
              <span className="font-bold text-lg">{pkg.package_name}</span>
              <span className="text-sm text-gray-500">{pkg.visible === "1" ? "مرئي" : "مخفي"}</span>
            </div>
            <div className="flex gap-4">
              <span>السعر: <span className="font-semibold">{pkg.price} {pkg.currency_symbol?.symbol}</span></span>
              <span>المدة: <span className="font-semibold">{pkg.validity} يوم</span></span>
            </div>
            <button
              className="mt-2 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition self-start"
              onClick={() => navigate(`/admin/packages/${pkg.id}/edit`)}
            >
              عرض
            </button>
          </div>
        ))}
      </div>
   
    </div>
  );
}
